import React from 'react';
import Loading from './Loading';

const RouteLoader = (load) => {
    let initialized;
    let component;
    return class Loader extends React.Component {
        constructor(props) {
            super(props);
            this.component = component;
        }
        componentDidMount() {
            if (initialized) {
                return;
            }
            initialized = true;
            load((Component) => {
                this.component = Component.default || Component;
                component = this.component;
                this.forceUpdate();
            });
        }
        render() {
            if (this.component) {
                return React.createElement(this.component, this.props);
            }
            return <Loading />;
        }
    };
};

export default RouteLoader;



/** WEBPACK FOOTER **
 ** ./src/Components/RouteLoader.js
 **/